import request from "../../../helpers/request";

export const getAlertasProperty = async (
  idLoja: number,
  idCliente: number,
  idRegional: number,
  apiKey?: string | null,
) => {
  const l = idLoja || 0;
  const c = idCliente || 0;
  const r = idRegional || 0;

  const url = `${process.env.REACT_APP_API}/Alerta/GetAllPorLoja/${l}/${c}/${r}`;

  const result = apiKey
    ? await request({ url, method: "GET", apiKey })
    : await request({ url, method: "GET" });

  return result.data;
};
